module.exports = __webpack_public_path__ + "static/img/保险公司名单-英@2x.3aa037f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/gjyxb/assets/en/保险公司名单-英@2x.png
// module id = 1499
// module chunks = 379